var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 39.4 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.4,0H10.98s-.04,.01-.06,.01c-.09,0-.18,.02-.27,.05-.03,.01-.06,.02-.09,.03-.1,.05-.2,.11-.28,.19,0,0,0,0,0,0L.29,10.27s0,0,0,0c-.08,.08-.14,.18-.19,.28-.01,.03-.02,.06-.03,.09-.03,.09-.05,.17-.05,.27,0,.02-.01,.04-.01,.06V55c0,.55,.45,1,1,1H38.4c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1ZM9.98,3.41v6.57H3.41L9.98,3.41Zm27.42,50.59H2V11.98H10.98c.55,0,1-.45,1-1V2h25.42V54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.27,28.32c.09,.28,.3,.5,.58,.61l6.85,2.75v9.32c0,.46,.31,.86,.76,.97,.08,.02,.16,.03,.24,.03,.36,0,.71-.2,.88-.53l7-13.08c.13-.25,.16-.54,.06-.81-.09-.26-.3-.48-.56-.59l-6.38-2.66V15.37c0-.45-.3-.85-.74-.96-.43-.12-.89,.07-1.12,.46l-7.48,12.63c-.15,.25-.18,.55-.09,.83Zm7.43-9.3v5.98c0,.4,.24,.77,.62,.92l5.98,2.5-4.6,8.59v-6.01c0-.41-.25-.78-.63-.93l-6.4-2.57,5.02-8.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveReviews);
export default __webpack_public_path__ + "static/media/live-reviews.77b32dcd20b6d871c088152956dc35ce.svg";
export { ForwardRef as ReactComponent };